import { Box, Button, Icon } from "@chakra-ui/react";
import { useState } from "react";
import { PiMinusCircleBold, PiPlusCircleBold } from "react-icons/pi";

import { StyledNavLinkMobile } from "@/components/navbar/mobile-navbar";
import { PageNavItem } from "@/components/navbar/use-navbar-pages";
import { PopoverContent, PopoverRoot, PopoverTrigger } from "@/components/ui/popover";
import { COLOR_TXT_PRIMARY } from "@/components/ui/theme";

export const MoreMenuNavbar = ({ pages }: { pages: PageNavItem[] }) => {
  const [open, setOpen] = useState(false);
  return (
    <PopoverRoot onOpenChange={(d) => setOpen(d.open)} open={open}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" borderRadius="24px" color="fg.muted">
          <Icon boxSize={4} mr={1.5}>
            {open ? <PiMinusCircleBold /> : <PiPlusCircleBold />}
          </Icon>
          {open ? "Less" : "More"}
        </Button>
      </PopoverTrigger>
      <PopoverContent p={2} rounded="xl">
        {pages.map((p) => (
          <Box key={p.name} onClick={() => setOpen(false)}>
            <StyledNavLinkMobile
              key={p.name}
              {...p}
              iconSize={8}
              styledOverrides={{
                padding: "4px",
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: "500",
                color: COLOR_TXT_PRIMARY,
              }}
            />
          </Box>
        ))}
      </PopoverContent>
    </PopoverRoot>
  );
};
